export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/empty.js
// module id = ./node_modules/d3-selection/src/selection/empty.js
// module chunks = 53